module.exports = __webpack_public_path__ + "static/media/transporter-2.cf1a2b81.svg";